<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.briefmaus_settings.form.api_sender')"
            :is-required="true"
            :hint="__('settings.briefmaus_settings.form.api_sender_hint')"
        >
            <DInput
                id="api_sender"
                v-model="form.api_sender"
                :placeholder="__('settings.briefmaus_settings.form.api_sender')"
                :is-valid="isFormFieldValid('api_sender')"
                :invalid-feedback="errors.api_sender"
                type="text"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.briefmaus_settings.form.api_receiver')"
            :is-required="true"
            :hint="__('settings.briefmaus_settings.form.api_receiver_hint')"
        >
            <DInput
                id="api_receiver"
                v-model="form.api_receiver"
                :placeholder="__('settings.briefmaus_settings.form.api_receiver')"
                :is-valid="isFormFieldValid('api_receiver')"
                :invalid-feedback="errors.api_receiver"
                type="text"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'BriefmausSettingsForm',
    props: {
        briefmausSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_sender: this.briefmausSettings?.api_sender ?? '',
                api_receiver: this.briefmausSettings?.api_receiver ?? '',
                postal_delivery: 'briefmaus'
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
